// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qk3q","rootNoMargin":"styles_rootNoMargin__32ZXN"};